import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { cn } from '@/lib/ui/utils';

/** Matches the SDK refetch cadence of the competition standings hooks. */
export const POLL_RING_INTERVAL_MS = 10_000;
export const POLL_RING_MINUTE_INTERVAL_MS = 60_000;
type PollRingIntervalMs = typeof POLL_RING_INTERVAL_MS | typeof POLL_RING_MINUTE_INTERVAL_MS;
interface PollRingProps {
  /** Change to restart the sweep — pass the query's `dataUpdatedAt`. */
  resetKey: number | string;
  label: string;
  intervalMs?: PollRingIntervalMs;
  className?: string | undefined;
}

// A polled surface has no push channel, so the ring is the freshness signal:
// one full sweep per refetch interval, restarted whenever fresh data lands.
export function PollRing(t0) {
  const $ = _c(14);
  const {
    resetKey,
    label,
    intervalMs: t1,
    className
  } = t0;
  const intervalMs = t1 === undefined ? POLL_RING_INTERVAL_MS : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("inline-flex items-center gap-1.5 text-caption text-foreground-tertiary", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <circle cx="8" cy="8" r="6.5" pathLength="1" fill="none" strokeWidth="2.5" className="stroke-background-tertiary" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== intervalMs) {
    t4 = <circle cx="8" cy="8" r="6.5" pathLength="1" fill="none" strokeWidth="2.5" strokeLinecap="round" data-interval-ms={intervalMs} className="morfi-poll-ring stroke-foreground-brand" />;
    $[3] = intervalMs;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== resetKey || $[6] !== t4) {
    t5 = <svg key={resetKey} viewBox="0 0 16 16" aria-hidden="true" className="size-icon-sm -rotate-90">{t3}{t4}</svg>;
    $[5] = resetKey;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== label) {
    t6 = <span>{label}</span>;
    $[8] = label;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t5 || $[12] !== t6) {
    t7 = <span data-testid="poll-ring" className={t2}>{t5}{t6}</span>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}